import type { StartFailure } from './parseStartError'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/** Признак мягкого «уже всё переведено»: контракт различает два
 *  `nothing_to_translate` ТОЛЬКО по тексту, кода на это нет. */
const ALREADY = /already has a translation/i

/**
 * Бизнес-отказы перевода (§7.1, §7.2). Все приходят `422` с объектным detail,
 * то есть в ветку `business` — ветвление по `code`, `never`-исчерпывность
 * `failureText` по `kind` не трогается.
 */
export const translationFailureText = (code: string, message: string): string | null => {
  const m = messagesNow(messages)
  switch (code) {
    case 'nothing_to_translate':
      return ALREADY.test(message) ? m.allTranslated : m.noTextYet
    case 'unsupported_language':
      return m.unsupportedLanguage
    case 'translation_storage_limit':
      // Единственный код словаря, приходящий НЕ со старта прогона: его отдаёт
      // ручка публикации языка (§3.6) на попытку объявить второй язык
      // перевода. Читатель — `TranslationLangRow` через тот же
      // `parseStartError` + `failureText`.
      return m.translationStorageLimit
    case 'translation_unpublished':
      // Смена базового: курс опубликован, а язык, который становится
      // оригиналом, скрыт — сервер не выпускает его в каталог молча.
      return m.translationUnpublished
    case 'cannot_delete_source':
      return m.cannotDeleteSource
    case 'translation_not_found':
      return m.translationNotFound
    case 'course_language_changed':
      // «Продолжить» после смены базового или удаления языка (§6.11):
      // продолжение писало бы перевод в слот, который теперь оригинал.
      return m.courseLanguageChanged
    case 'not_cancellable':
      return m.notCancellable
    case 'job_already_finished':
      return m.jobAlreadyFinished
    default:
      return null
  }
}

/** Единственный отказ перевода с осмысленным действием: предложить
 *  «перевести заново». Подставлять `overwrite` автоматически ЗАПРЕЩЕНО. */
export const isNothingToTranslateSoft = (failure: StartFailure | null): boolean =>
  failure?.kind === 'business' &&
  failure.code === 'nothing_to_translate' &&
  ALREADY.test(failure.message)
